// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/accordion","root":"accordion-m__root__2v9pC","paneRoot":"accordion-m__paneRoot__1l_JD","paneOpen":"accordion-m__paneOpen__APMV0"};